import { dexie } from "../db"
import {
  findFirstUnfinishedOrderedStep,
  modifyOrderedStep,
  type OrderedStepLocal,
} from "../tables/orderedSteps/orderedSteps"
import { logDexieError } from "../utils/logDexieError"

export async function finishAndGetNextStep(name: string, sessionId: string): Promise<OrderedStepLocal | undefined> {
  try {
    return await dexie.transaction("rw", dexie.orderedSteps, async () => {
      await modifyOrderedStep(name, sessionId, { isFinished: true })
      return findFirstUnfinishedOrderedStep(sessionId)
    })
  } catch (error) {
    logDexieError(error)
  }
}
